module.exports = __webpack_public_path__ + "static/media/tools-zoom.26bab70e.svg";